(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/active-quickgames-suspension.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/active-quickgames-suspension.js');
'use strict';

const _svs$ui$ReactCard = svs.ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardBody = _svs$ui$ReactCard.CardBody;
const _svs$spelpaus$pages$s = svs.spelpaus.pages.svsSuspension.SvsSuspensionHelper,
  getProductText = _svs$spelpaus$pages$s.getProductText,
  getSuspensionTypeText = _svs$spelpaus$pages$s.getSuspensionTypeText,
  getActiveValideToDate = _svs$spelpaus$pages$s.getActiveValideToDate,
  getActiveValideToDateTime = _svs$spelpaus$pages$s.getActiveValideToDateTime;
const ActiveQuickGamesSuspension = _ref => {
  let suspension = _ref.suspension;
  return React.createElement(Card, {
    className: "margin-top-1"
  }, React.createElement(CardBody, null, React.createElement("h5", {
    className: "card-title"
  }, getProductText(suspension.product, suspension.type), ' ', getSuspensionTypeText(suspension.period, suspension.terminationPeriod)), React.createElement("p", {
    className: "card-text"
  }, ' ', "Spelpausen g\xE4ller till", ' ', getActiveValideToDate(suspension), "."), React.createElement("p", {
    className: "card-text"
  }, "Skrapspel", React.createElement("br", null), "Triss", React.createElement("br", null), "KenoXpress", React.createElement("br", null), "Fler lotter"), suspension.terminable && React.createElement("p", {
    className: "card-text"
  }, "Kontakta Kundservice efter spelpaus f\xF6r att aktivera", ' ', getProductText(suspension.product, suspension.type), ' ', "efter", ' ', getSuspensionTypeText(suspension.period, suspension.terminationPeriod), "."), !suspension.terminable && React.createElement("p", {
    className: "card-text"
  }, "Spelpausen upph\xF6r automatiskt efter", ' ', suspension.period === 0 ? getActiveValideToDateTime(suspension.validTo) : getSuspensionTypeText(suspension.period, suspension.terminationPeriod), ".")));
};
svs.spelpaus.pages.svsSuspension.components.ActiveQuickGamesSuspension = ActiveQuickGamesSuspension;

 })(window);